import { compact } from "lodash";
import { useComponentStoreV2 } from "../component";
import { isBuiltCampaignComponentVariable } from "../component-built/setting/model/BuiltCampaignComponentVariable";
import { useComponentGraphStoreV2 } from "../component-graph-v2";
const serializeValues = (setting) => {
    if (setting && Object.hasOwnProperty.call(setting, "values")) {
        return JSON.stringify(setting.values);
    }
    return "";
};
class ComponentVariableSearchableBuilder {
    constructor(builtSetting) {
        this.setting = null;
        this.nodeType = null;
        this.withNodeType = (nodeType) => {
            this.nodeType = nodeType;
            return this;
        };
        this.builtSetting = builtSetting;
    }
    withSetting(setting) {
        this.setting = setting;
        return this;
    }
    build() {
        var _a;
        const valuesSerialized = serializeValues(this.setting);
        const builtValuesSerialized = serializeValues(this.builtSetting);
        const importance = ((_a = this.builtSetting) === null || _a === void 0 ? void 0 : _a.getImportance()) || "BASIC";
        const isInheriting = isBuiltCampaignComponentVariable(this.builtSetting)
            ? this.builtSetting.isInheriting()
            : false;
        return {
            name: this.builtSetting.name,
            valuesSerialized,
            builtValuesSerialized,
            isTranslatable: this.builtSetting.isTranslatable(),
            importance,
            primaryCategory: this.builtSetting.getPrimaryCategory(),
            secondaryCategory: this.builtSetting.getSecondaryCategory(),
            nodeType: this.nodeType,
            isInheriting,
            priority: this.builtSetting.priority,
            componentId: this.builtSetting.context.componentId,
            isAdvanced: this.builtSetting.isAdvanced(),
            displayName: this.builtSetting.display_name,
            isExpert: this.builtSetting.isHidden(),
            isUIDisplayOnly: this.builtSetting.isUIDisplayOnly(),
            isExplicitlyCategorized: this.builtSetting.isExplicitlyCategorized(),
        };
    }
}
export const createComponentVariableSearchables = (builtComponent) => {
    const componentStore = useComponentStoreV2();
    const componentGraphStore = useComponentGraphStoreV2();
    const searchableBuilders = {};
    const getOrCreateSearchableBuilder = (builtVariable) => {
        if (!searchableBuilders[builtVariable.name]) {
            searchableBuilders[builtVariable.name] =
                new ComponentVariableSearchableBuilder(builtVariable);
        }
        return searchableBuilders[builtVariable.name];
    };
    const component = componentStore.getComponent(builtComponent.id);
    builtComponent.listSettings().forEach((builtSetting) => {
        const searchableBuilder = getOrCreateSearchableBuilder(builtSetting);
        const componentVariable = component === null || component === void 0 ? void 0 : component.findVariable(builtSetting.name);
        if (componentVariable) {
            searchableBuilder.withSetting(componentVariable);
        }
        const nodeContext = componentGraphStore.getComponentVariableNodeContext(builtComponent.id, builtSetting.name);
        if (nodeContext) {
            searchableBuilder.withNodeType(nodeContext.type);
        }
    });
    return compact(Object.values(searchableBuilders).map((builder) => builder.build()));
};
